// extracted by mini-css-extract-plugin
export default {"container":"common_section-module__container--zUSTY"};